export const buyerInitials = (name = "") => name
  .split(" ")
  .filter(Boolean)
  .map((part) => part[0])
  .slice(0, 2)
  .join("");
